module.exports = __webpack_public_path__ + "img/ic_flag_turkey.379811ce.svg";